import {ModifyQuestionTranslationText} from "../../i18n/TanslationHelper";
import store from "../../redux";
import moment from "moment";
import "moment/locale/nl"; // Import Dutch locale for moment.js

const getChatQuestions = ({
                           T,
                           index,
                           to = '',
                           from = '',
                           travelers = '',
                           infants = '',
                           leaveTime = '',
                           nightCount = ''
                       }) => {
    const state = store.getState();
    const loginconfig = state.loginconfig;

    const questions = [
        T('Chat:Chat_Bot_Question_Where_Want_To_Go'), // 0
        T('Chat:Chat_Bot_Question_From_Airport'), // 1
        T('Chat:Chat_Bot_Question_Traveler_Count'), // 2
        T('Chat:Chat_Bot_Question_When_Leave'), // 3
        T('Chat:Chat_Bot_Question_How_Many_Nights'), // 4
        T('Chat:Chat_Bot_Question_Still_From_Airport', {from: from}), // 5
        ModifyQuestionTranslationText({
            message: T('Chat:Chat_Bot_Question_Still_Travelers_Count', {travelers: travelers}),
            params: {
                travelers: travelers,
            },
            language: loginconfig?.locale?.short,
        }), // 6
        T('Chat:Chat_Bot_Question_Surprise_Where_Want_To_Go'), // 7
        T('Chat:Chat_Bot_Baby_Traveler_Count'), // 8
        ModifyQuestionTranslationText({
            message: T('Chat:Chat_Bot_Previous_Baby_Travelers_Count', {
                infants: infants,
            }),
            params: {
                infants: infants,
            },
            language: loginconfig?.locale?.short,
        }), // 9
        (() => {
            // Re-format leaveTime with the current locale
            let formattedLeaveTime = leaveTime;
            if (leaveTime) {
                const momentLocale = loginconfig?.locale?.code ? loginconfig.locale.code.split('_')[0].toLowerCase() : 'en';
                // Try parsing with current locale first, then fallback to English
                let parsedDate = moment(leaveTime, ["DD MMMM YYYY", "DD MMMM", "MMMM DD YYYY", "MMMM DD", moment.ISO_8601], momentLocale);
                
                if (!parsedDate.isValid()) {
                    // Try parsing with English locale if current locale fails
                    parsedDate = moment(leaveTime, ["DD MMMM YYYY", "DD MMMM", "MMMM DD YYYY", "MMMM DD", moment.ISO_8601], 'en');
                }
                
                formattedLeaveTime = parsedDate.isValid() 
                    ? parsedDate.locale(momentLocale).format("DD MMMM YYYY")
                    : leaveTime; // Fallback to original if parsing fails
            }
            return T('Chat:Chat_Bot_Previous_When_Leave', {
                leaveTime: formattedLeaveTime,
            });
        })(), // 10
        T('Chat:Chat_Bot_Previous_Where_Want_To_Go', {to: to}), // 11
        T('Chat:Chat_Bot_Previous_How_Many_Nights', {
            nightCount: nightCount,
        }), // 12
        // t('chatPage:howMuchSpend'),
        T('Chat:Chat_Bot_How_Much_Spend'), // 13
        T("Chat:Chat_Bot_Helping_Greetings_Text"), // 14
    ];

    return questions[index];
};

export default getChatQuestions;
